import { format, parse } from "date-fns";

const DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const parseDate = (date: string) => {
    return parse(date, DATETIME_FORMAT, Date.now());
};

export const formatDate = (localDate: Date | number) => {
    return `${format(localDate, DATETIME_FORMAT)}+00:00`;
};

/**
 * Parse a timezoneless datetime string sent by the API (format `yyyy-MM-ddTHH:mm:ss`)
 * as UTC. Unlike `parseDate`, which interprets the string in the browser's local
 * timezone, this returns the correct instant so it can be displayed in the user's
 * local time.
 */
export const parseUtcDate = (date: string) => {
    return new Date(`${date}Z`);
};
